<template>
  <div class="seomain">
    <!-- <div class="info-main">
      <div class="info-top">
        <span>工单号：</span>
        {{ stinfo.order_code }}
      </div>
      <div class="info-mid">
        <h1>{{ stinfo.product_sku }}</h1>
        <p>设备SN号</p>
      </div>
      <div class="info-bottom text-center">
        <dl>
          <dt>资产编码</dt>
          <dd>{{ stinfo.inventory_code }}</dd>
        </dl>
        <dl>
          <dt>设备型号</dt>
          <dd>{{ stinfo.product_name }}</dd>
        </dl>
      </div>
    </div> -->
    <div class="tab-content">
      <div class="st-list-box pan-105">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="st-list-xs" v-for="(v, k) in stlist" :key="k" :index="k">
            <div class="st-list-top-xs">
              <div class="t-tit-xs">工单号:{{ v.code }}</div>
            </div>
            <div class="st-list-main">
              <p>设备类型 ：{{ v.devicetype }}</p>
              <p>设备SN号 ：{{ v.servicetag }}</p>
              <p>资产编号 ：{{ v.assetnumber }}</p>
              <p>设备型号 ：{{ v.model }}</p>
              <p>机框SN ：{{ v.framesn }}</p>
              <p>数量 ：{{ v.quantity }}</p>
              <p>CPU型号 ：{{ v.cpumodel }}</p>
              <p>CPU数量 ：{{ v.cpuquantity }}</p>
              <p>内存单条容量 ：{{ v.ramcapacity }}</p>
              <p>内存数量 ：{{ v.ramquantity }}</p>
              <p>内存总容量 ：{{ v.ramcapacity_total }}</p>
              <p>GPU型号 ：{{ v.gpumodel }}</p>
              <p>GPU数量 ：{{ v.gpuquantity }}</p>
              <p>网卡型号 ：{{ v.ncmodel }}</p>
              <p>网卡数量 ：{{ v.ncquantity }}</p>
              <p>FPGA型号 ：{{ v.fpgamodel }}</p>
              <p>FPGA数量 ：{{ v.fpgaquantity }}</p>
              <p>HBA型号 ：{{ v.hbamodel }}</p>
              <p>HBA数量 ：{{ v.hbaquantity }}</p>
              <p>设备状态 ：{{ v.devicestatus }}</p>
              <p>核验结果：{{ v.verification }}</p>
              <p>核验人：{{ v.acceptor }}</p>
              <p>备注：{{ v.remark }}</p>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      finished: false,
      page: 1,
      stlist: [],
      activeid: 0,
    };
  },
  watch: {},
  computed: {},
  methods: {
    async onLoad() {
      let code = this.$route.params.code;
      let result = await this.$post(this.$api.stGetXiajiagongdanInfo, { code, page: this.page });

      if (result.data.length == 0) return (this.finished = true);
      // 进行操作
      this["stlist"].push(...result.data);
      // 操作完成
      this.page += 1;
      this.loading = false;
    },
  },
  created() {
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "下架工单详情" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.tab-content .st-list-xs {
  margin-bottom: 10px;
  background: #fff;
}
.st-list-top-xs {
  background: #677588;
  text-align: center;
}
.t-tit-xs {
  color: #fff;
  line-height: 2.6;
}
.st-list-main {
  padding: 10px 15px;
}
</style>
<style lang="scss" scoped>
/* .info-main {
  padding-top: 10px;
  background: #345;
  margin-bottom: 15px;
}
.info-main .info-top {
  color: #9ab;
  line-height: 2;
  margin: 0 20px;
}
.info-main .info-mid {
  text-align: center;
  color: #fff;
}
.info-main .info-mid h1 {
  line-height: 2.2;
  font-weight: normal;
}
.info-main .info-mid p {
  color: #9ab;
}
.info-main .info-bottom {
  display: flex;
  background: #2f3e50;
  border-top: 1px solid #9ab;
  margin-top: 20px;
  padding: 5px 0;
}
.info-main .info-bottom dl {
  flex: 1;
  line-height: 1.8;
}
.info-main .info-bottom dt {
  color: #9ab;
}
.info-main .info-bottom dd {
  color: #fff;
}

.p-0 {
  padding: 7px 0px;
}
.none-line.van-cell::after {
  display: none;
} */
</style>
